export default "__VITE_ASSET__BnMEeZa4__"